import { render, staticRenderFns } from "./UnregisterPage.vue?vue&type=template&id=9c522b98&scoped=true&"
import script from "./UnregisterPage.vue?vue&type=script&lang=js&"
export * from "./UnregisterPage.vue?vue&type=script&lang=js&"
import style0 from "./UnregisterPage.vue?vue&type=style&index=0&id=9c522b98&lang=scss&scoped=true&"
import style1 from "./UnregisterPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c522b98",
  null
  
)

export default component.exports